

import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FireIcon,
  FolderIcon,
  EnvelopeIcon,
  GlobeAltIcon,
  TrophyIcon,
  ClockIcon,
  UserGroupIcon,
  MegaphoneIcon
} from '@heroicons/react/24/outline';
import { usePopularPosts } from '../../hooks/usePopularPosts';
import { useCategories } from '../../hooks/useCategories';
import { stripHtml, formatDate } from '../../services/utils';

const Sidebar = () => {
  const { popularPosts, loading: popularLoading } = usePopularPosts(5);
  const { categories, loading: categoriesLoading } = useCategories();
  
  const mainCategories = categories.filter(cat => cat.parent === 0).slice(0, 6);

  return (
    <aside className="space-y-6">

      {/* Articles populaires */}
      <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-red-600  mt-20">
        <div className="flex items-center space-x-3 mb-6">
          <div className="p-2 bg-gradient-to-r from-red-600 to-red-700 rounded-lg">
            <FireIcon className="w-5 h-5 text-white" />
          </div>
          <h3 className="text-xl font-bold text-slate-800">Articles populaires</h3>
        </div>
        
        {popularLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="animate-pulse">
                <div className="flex items-start space-x-3">
                  <div className="w-10 h-10 bg-slate-200 rounded-full"></div>
                  <div className="flex-1">
                    <div className="h-4 bg-slate-200 rounded mb-2"></div>
                    <div className="h-3 bg-slate-200 rounded w-3/4"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="space-y-4">
            {popularPosts.map((post, index) => (
              <div key={post.id} className="group flex items-start space-x-3 p-3 rounded-lg hover:bg-slate-50 transition-all duration-300">
                <div className="flex-shrink-0 relative">
                  <div className="w-10 h-10 bg-gradient-to-r from-blue-800 to-blue-900 text-white rounded-full flex items-center justify-center text-sm font-bold shadow-lg">
                    {index + 1}
                  </div>
                  {index === 0 && (
                    <TrophyIcon className="w-4 h-4 text-yellow-500 absolute -top-1 -right-1" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-semibold text-slate-800 line-clamp-2 leading-tight">
                    <Link 
                      to={`/article/${post.slug}`} 
                      className="hover:text-red-600 transition-colors duration-300"
                    >
                      {stripHtml(post.title?.rendered || post.title)}
                    </Link>
                  </h4>
                  <div className="flex items-center space-x-2 mt-2 text-xs text-slate-500">
                    <ClockIcon className="w-3 h-3" />
                    <span>{formatDate(post.date)}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Catégories */}
      {/* <div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-blue-800">
        <div className="flex items-center space-x-3 mb-6">
          <div className="p-2 bg-gradient-to-r from-blue-800 to-blue-900 rounded-lg">
            <FolderIcon className="w-5 h-5 text-white" />
          </div>
          <h3 className="text-xl font-bold text-slate-800">Catégories</h3>
        </div>
        
        {categoriesLoading ? (
          <div className="space-y-2">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="h-12 bg-slate-200 rounded-lg animate-pulse"></div>
            ))}
          </div>
        ) : (
          <div className="space-y-2">
            {mainCategories.map(category => (
              <Link
                key={category.id}
                to={`/category/${category.slug}`}
                className="flex items-center justify-between p-3 rounded-lg hover:bg-gradient-to-r hover:from-blue-50 hover:to-red-50 transition-all duration-300 group border border-transparent hover:border-slate-200"
              >
                <span className="text-sm font-semibold text-slate-700 group-hover:text-blue-800 transition-colors">
                  {category.name}
                </span>
                <span className="text-xs text-slate-500 bg-slate-100 px-3 py-1 rounded-full group-hover:bg-gradient-to-r group-hover:from-blue-600 group-hover:to-red-600 group-hover:text-white transition-all">
                  {category.count}
                </span>
              </Link>
            ))}
          </div>
        )}
      </div> */}

      {/* Newsletter */}
      <div className="bg-gradient-to-br from-red-600 via-red-700 to-blue-800 rounded-xl shadow-lg p-6 text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-red-600/20 to-blue-800/20 opacity-50"></div>
        <div className="relative z-10">
          <div className="flex items-center space-x-3 mb-4">
            <div className="p-2 bg-white/20 backdrop-blur-sm rounded-lg">
              <EnvelopeIcon className="w-5 h-5 text-white" />
            </div>
            <h3 className="text-xl font-bold">Newsletter</h3>
          </div>
          <p className="text-sm mb-6 text-white/90 leading-relaxed">
            Recevez les dernières actualités du Bambouck directement dans votre boîte mail.
          </p>
          <form className="space-y-3">
            <input
              type="email"
              placeholder="Votre adresse email"
              className="w-full px-4 py-3 rounded-lg text-slate-800 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-white/50 backdrop-blur-sm bg-white/95 transition-all"
            />
            <button
              type="submit"
              className="w-full bg-white text-red-600 py-3 rounded-lg font-semibold hover:bg-slate-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              S'abonner gratuitement
            </button>
          </form>
        </div>
      </div>
{/* Réseaux sociaux - Sidebar */}
<div className="bg-white rounded-xl shadow-lg p-6 border-l-4 border-red-600">
  <div className="flex items-center space-x-3 mb-6">
    <div className="p-2 bg-gradient-to-r from-red-600 to-blue-800 rounded-lg">
      <GlobeAltIcon className="w-5 h-5 text-white" />
    </div>
    <h3 className="text-xl font-bold text-slate-800">Suivez-nous</h3>
  </div>
  
  <div className="space-y-3">
    <a
      href="https://www.facebook.com/xibarubambouck"
      className="flex items-center space-x-4 p-4 rounded-lg hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 transition-all duration-300 group border border-transparent hover:border-blue-200 hover:shadow-md"
    >
      <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-blue-700 rounded-full flex items-center justify-center shadow-lg">
        <span className="text-white text-sm font-bold">f</span>
      </div>
      <div className="flex-1">
        <span className="text-sm font-semibold text-slate-700 group-hover:text-blue-700 transition-colors">
          Facebook
        </span>
        <p className="text-xs text-slate-500">Suivez nos actualités</p>
      </div>
      <UserGroupIcon className="w-4 h-4 text-slate-400 group-hover:text-blue-600 transition-colors" />
    </a>
    
    <a
      href="https://api.whatsapp.com/send?phone=221774369394&text&context=AffoSsEX08EdK4TvEUB_dFo3fxt0V8tZAjxL81kqh00KnFdqOnaIRImX5cTDegr2g9XrVsCnHckRwbk0esv0NbUN_wEmFGcpFbq0leVV9clltGjIyKjMKgD4rv3DdsZecmv3lTWLyYEYp8xvhjCNKFsGqg&source&app=facebook"
      className="flex items-center space-x-4 p-4 rounded-lg hover:bg-gradient-to-r hover:from-green-50 hover:to-green-100 transition-all duration-300 group border border-transparent hover:border-green-200 hover:shadow-md"
    >
      <div className="w-10 h-10 bg-gradient-to-r from-green-600 to-green-700 rounded-full flex items-center justify-center shadow-lg">
        <span className="text-white text-sm font-bold">W</span>
      </div>
      <div className="flex-1">
        <span className="text-sm font-semibold text-slate-700 group-hover:text-green-600 transition-colors">
          WhatsApp
        </span>
        <p className="text-xs text-slate-500">Contactez-nous directement</p>
      </div>
      <UserGroupIcon className="w-4 h-4 text-slate-400 group-hover:text-green-600 transition-colors" />
    </a>
    
    <a
      href="https://www.youtube.com/@user-ij6tn9lu5b"
      className="flex items-center space-x-4 p-4 rounded-lg hover:bg-gradient-to-r hover:from-red-50 hover:to-red-100 transition-all duration-300 group border border-transparent hover:border-red-200 hover:shadow-md"
    >
      <div className="w-10 h-10 bg-gradient-to-r from-red-600 to-red-700 rounded-full flex items-center justify-center shadow-lg">
        <span className="text-white text-sm font-bold">YT</span>
      </div>
      <div className="flex-1">
        <span className="text-sm font-semibold text-slate-700 group-hover:text-red-600 transition-colors">
          YouTube
        </span>
        <p className="text-xs text-slate-500">Vidéos et contenus</p>
      </div>
      <UserGroupIcon className="w-4 h-4 text-slate-400 group-hover:text-red-600 transition-colors" />
    </a>
  </div>
</div>

      {/* Publicité */}
      {/* <div className="bg-gradient-to-br from-slate-100 to-slate-200 rounded-xl shadow-lg p-6 text-center border-l-4 border-slate-400"> */}
        {/* <div className="flex items-center justify-center space-x-2 mb-4">
          <MegaphoneIcon className="w-5 h-5 text-slate-600" />
          <h3 className="text-sm font-bold text-slate-600 uppercase tracking-wider">Publicité</h3>
        </div> */}
        {/* <div className="bg-white rounded-lg p-8 border-2 border-dashed border-slate-300 hover:border-slate-400 transition-colors">
          <div className="text-slate-500">
            <MegaphoneIcon className="w-8 h-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm font-medium">
              Espace publicitaire
            </p>
            <p className="text-xs mt-1 opacity-75">
              300x250
            </p>
          </div>
        </div> */}
        {/* <a 
  href="https://1xbet.com/sn" 
  target="_blank" 
  rel="noopener noreferrer"
  className="block overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
>
  <img 
    src="/images/1xbet-sidebar.jpg" 
    alt="1xBet - Pariez maintenant" 
    className="w-full h-auto"
  />
</a> */}

      {/* </div> */}
    </aside>
  );
};

export default Sidebar;